import React from "react";

export default function LayoutModalBody({ children }) {
  return <div>{children}</div>;
}
